const initialState = {
  detail: {},
  fetchStakePending:false,
  fetchApprovalPending: false
};

export default initialState;
